<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="mb-0 fw-bold">{{ 'PEOPLE.TITLE' | translate }}</h1>
  <button id="addPerson" class="btn btn-primary fw-bold mb-3 bi-plus-lg" type="button" (click)="openAddPersonModal()">
    {{ 'PEOPLE.ADD_NEW_PERSON' | translate }}
  </button>
</div>

<div>
  @if (showEditPersonModal) {
<app-people-add-modal
   
    [personToEdit]="personToEdit"
    (personFormSubmitted)="addOrEditPerson($event)">
  </app-people-add-modal>
}

  @if (showTeamAssignationModal) {
<app-team-assignation-modal
   
    [people]="personToEdit"
    (modalClosed)="editTeamAssignation($event)">
  </app-team-assignation-modal>
}

</div>
<div class="row d-flex align-items-center justify-content-between mb-3">
  <div class="col-12 card rounded-3 p-3 border-0 shadow-sm">
    <form class="search-container" [formGroup]="search">
      <div class="row g-3"> 
        <div class="col-md"> 
          <div class="form-floating">
            <input type="text" id="name" class="form-control" formControlName="name" placeholder="{{ 'COMMON.SEARCH.PEOPLE_NAME' | translate }}" />
            <label for="name">{{ 'COMMON.SEARCH.PEOPLE' | translate }}</label>
            @if (search.controls.name.value) {
              <button
              type="button"
              class="btn-clear-search"
              (click)="resetSearchField('name')"
              title="{{ 'COMMON.CLEAR_SEARCH' | translate }}"
              >
                <i class="bi bi-x-circle"></i> 
              </button>
            }
          </div>
        </div>

        <div class="col-md">
          <div class="form-floating">
            <select id="role" class="form-select" formControlName="roleId">
              <option value="">{{ 'COMMON.SEARCH.ALL' | translate }}</option>
              @for (role of rolesFilter$ | async; track role.id) {
                <option [value]="role.id">{{ role.name }}</option>
              }
            </select>
            <label for="role">{{ 'COMMON.SEARCH.ROLE' | translate }}</label>
            @if (search.controls.roleId.value) {
              <button
              type="button"
              class="btn-clear-search btn-clear-select"
              (click)="resetSearchField('roleId')"
              title="{{ 'COMMON.CLEAR_SEARCH' | translate }}"
            >
              <i class="bi bi-x-circle "></i> 
            </button>
            }
          </div>
        </div>

        <div class="col-md">
          <div class="form-floating">
            <select id="team" class="form-select" formControlName="teamId">
              <option value="">{{ 'COMMON.SEARCH.ALL' | translate }}</option>
              @for (team of teamsFilter$ | async; track team.id) {
              <option [value]="team.id">{{ team.name }}</option>
              }
            </select>
            <label for="team">{{ 'COMMON.SEARCH.TEAM' | translate }}</label>
            @if (search.controls.teamId.value) {
            <button
              type="button"
              class="btn-clear-search btn-clear-select"
              (click)="resetSearchField('teamId')" title="{{ 'COMMON.CLEAR_FILTER' | translate }}"
            >
              <i class="bi bi-x-circle"></i>
            </button>
            }
          </div>
        </div>

        <div class="col-md">
          <div class="form-floating">
            <select id="status" class="form-select" formControlName="status">
              <option value="">{{ 'COMMON.SEARCH.ALL' | translate }}</option>
              <option value="contractor">{{ 'COMMON.SEARCH.CONTRACTOR' | translate }}</option>
              <option value="internal">{{ 'COMMON.SEARCH.INTERNAL' | translate }}</option>
            </select>
            <label for="status">{{ 'COMMON.SEARCH.STATUS' | translate }}</label>
            @if (search.controls.status.value) {
              <button
              type="button"
              class="btn-clear-search btn-clear-select"
              (click)="resetSearchField('status')" title="{{ 'COMMON.CLEAR_FILTER' | translate }}"
              >
              <i class="bi bi-x-circle"></i>
            </button>
            }
          </div>
        </div>

      </div> 
    </form>
  </div>
</div>
<!-- HideAfter -->
@if (errorMessage) {
<div class="alert alert-danger" HideAfter>
  <i class="bi-exclamation-circle mr-2"></i>
  {{ errorMessage }}
  <i class="bi-x" style="font-size: 2rem;"></i>
</div>
}
@if (isLoading) {
<div class="text-center my-4">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
}
<table class="table table-hover table-striped rounded-3">
  <thead>
    <tr>
      <th scope="col">{{ 'PEOPLE.FULL_NAME' | translate }}</th>
      <th scope="col">{{ 'PEOPLE.ROLE' | translate }}</th>
      <th scope="col">{{ 'PEOPLE.TEAMS' | translate }}</th>
      <th scope="col">{{ 'PEOPLE.ALLOCATION_RATE' | translate }}</th>
      <th scope="col">{{ 'PEOPLE.STATUS' | translate }}</th>
      <th scope="col">{{ 'COMMON.CREATED_AT' | translate }}</th>
      <th scope="col">{{ 'COMMON.UPDATED_AT' | translate }}</th>
      <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (people of peoples$ |async; track people.id) {
    <tr [ngClass]="getPersonHiringStatusClass(people)">
      <td>
        <div class="d-flex align-items-center">
          <a [routerLink]="['/peoples', people.id]" class="fw-bold">
            <app-avatar [personOrPeople]="people" size="normal" shape="circle" class="me-1"></app-avatar>
            {{ people.firstName }} {{ people.lastName }}
          </a>
          @if (getPersonStatusIconAndMessage(people); as statusInfo) {
          <app-people-status-icon
              [icon]="statusInfo.icon"
              [color]="statusInfo.color"
              [message]="statusInfo.message"
              [date]="statusInfo.date">
          </app-people-status-icon>
          } 
        </div>
      </td>
      <td>
        @if (people.role) {
        <span class="badge bg-secondary">
          <a [routerLink]="['/roles', people.role.id]">{{ people.role.name }}</a>
        </span>
        } @else {
        <span class="text-muted fst-italic small">{{ 'PEOPLE.NO_ROLE' | translate }}</span>
        }
      </td>
      <td>
        @if (people.teams) {
          @for (teamAllocation of people.teams; track teamAllocation.team.id) {
          <span
            class="badge text-dark me-1 mb-1"
            [ngStyle]="{'background-color': getTeamColor(teamAllocation.team.name)}"
          >
            <a [routerLink]="['/teams', teamAllocation.team.id]">{{ teamAllocation.team.name }}</a>
          </span>
          }
        }@else{
          <span class="text-muted fst-italic small">{{ 'PEOPLE.NO_TEAM' | translate }}</span>
        }
      </td>
      <td>
        @if (people.total_allocation_rate !== undefined) {
          <div 
            class="progress" 
            [title]="
              people.total_allocation_rate < 70
                ? ('PEOPLE.ALLOCATION_STATUS.AVAILABLE' | translate)
                : (people.total_allocation_rate < 100
                    ? ('PEOPLE.ALLOCATION_STATUS.ALMOST_FULL' | translate)
                    : ('PEOPLE.ALLOCATION_STATUS.FULL' | translate))
            "
            style="min-width: 100px; margin-bottom: 2px;"
            [style.height.px]="7">
            <div
              class="progress-bar rounded-pill"
              [ngClass]="getAllocationRateClass(people)"
              role="progressbar"
              [style.width.%]="people.total_allocation_rate > 100 ? 100 : people.total_allocation_rate"
              [attr.aria-valuenow]="people.total_allocation_rate"
              aria-valuemin="0"
              aria-valuemax="100"
            >
            </div>
          </div>

          <span class="d-block small text-muted ">
            {{ people.total_allocation_rate }}%
          </span>
        } @else {
          <span class="text-muted fst-italic">-</span>
        }
      </td>
      <td>
        <app-people-status [person]="people"></app-people-status>
      </td>
      <td class="date-cell">
        <span
          class="d-inline-flex align-items-center small text-muted"
          [attr.title]="people.createdAt | date: 'dd MMM yyyy HH:mm'"
          
        >
          <i class="bi bi-calendar3 me-1"></i>
          {{ people.createdAt | date: 'dd MMM yyyy' }}
        </span>
      </td>
      <td class="date-cell">
        <span
          class="d-inline-flex align-items-center small text-muted"
          [attr.title]="people.updatedAt | date: 'dd MMM yyyy HH:mm'"
        >
          <i class="bi bi-calendar3 me-1"></i>
          {{ people.updatedAt | date: 'dd MMM yyyy' }}
        </span>
      </td>
      <td>
        <div class="btn-group" role="group">
          <button title="{{ 'COMMON.EDIT' | translate }}" class="btn btn-outline-primary btn-sm rounded-pill border-0 me-1 editPerson" (click)="openEditPersonModal(people)">
            <i class="bi bi-pencil-fill"></i>
          </button>
          <button title="{{ 'COMMON.DELETE' | translate }}" class="btn btn-outline-danger btn-sm rounded-pill border-0 me-1 deletePerson" (click)="confirmDelete(people)">
            <i class="bi bi-trash-fill"></i>
          </button>
          <button title="{{ 'PEOPLE.ASSIGN' | translate }}" class="btn btn-outline-secondary btn-sm rounded-pill border-0 assignTeams" (click)="openTeamAssignationModal(people)">
            <i class="bi bi-people-fill"></i>
          </button>
        </div>
      </td>
    </tr>
  }
  </tbody>
</table>
@if (showConfirmDialog) {
<app-confirm-dialog
 
  (confirm)="handleConfirmDelete($event)">
</app-confirm-dialog>
}
